import {
    appendQueryParam, removeQueryParam, replaceQueryParam,
} from '@js/helpers/location';
import {initRankingRowShare, highlightViewedOrganization} from '@js/components/shareRankingResult';
import initAppliedFiltersListeners from '@js/modules/public/rankings/institutional/view/components/appliedFilters';
import {
    initLockFilterYear,
    initSelectsWithLiveSearch,
} from '@js/modules/public/rankings/institutional/view/helpers';
import {refreshRankingPage} from '@js/modules/public/rankings/subject/view/helper';
import initReportMistakeButton from '@js/components/reportMistakeForm';
import {showMoreNews} from '@js/modules/public/rankings/institutional/view/index';
import {switchTab} from "@js/helpers/tabSwitcher";

let sidebar;

$(() => {
    initFiltersListeners();
    initAppliedFiltersListeners();
    initRankingRowShare($('.ranking-row-share'));
    highlightViewedOrganization();
    initSelectsWithLiveSearch();
    initLockFilterYear();
    initReportMistakeButton($('.report-mistake__btn'));
    initRankingResultsListeners();

    const urlAnchor = location.hash;
    if (urlAnchor !== '') {
        switchTab(urlAnchor);
    }

    $('body')
        .on('click', '#morenews', showMoreNews)
        .on('click', '#main_page_link_to_promo', () => {
            $('body,html').animate({scrollTop: 0}, 300);
            switchTab('#promo');
        })
        .on('click', '.sorting-column', function () {
            const $column = $(this);
            const isActive = $column.attr('data-sorting-applied') === 'true';
            if (!isActive) {
                let queryParams = $('form#filters').serialize();
                const sortingColumn = $column.attr('data-sorting-column');
                queryParams = replaceQueryParam(queryParams, 'sort_by', sortingColumn);
                refreshRankingPage(false, queryParams);
            }
        })
        .on('show.bs.tab', 'a[data-toggle="tab"]', (e) => {
            document.location.hash = $(e.target).attr("href");
            $('body').animate({scrollTop: 0}, 0);
        });
});

function initRankingResultsListeners() {
    $('.ranking-results').find('.best-grade')
        .tooltip({
            title: 'Лучшая оценка',
            container: 'body',
            placement: 'bottom',
        });
}

function initFiltersListeners() {
    const $wrapper = $('body');
    const $filters = $wrapper.find('#filters');
    $filters
        .on('change', '#vedom, #grade, #ugs, #name, #organization, #league, #year', () => {
            const $changedControl = $(this);
            const appendCompareOrganizationParams = $changedControl.attr('id') !== 'name';
            refreshRankingPage(appendCompareOrganizationParams, null);
        })
        .on('change', '[name="group_mode_subject"]', function () {
            toggleGroupModeSubjectFilter($(this));
        });
    const $modalFiltersForm = $('#modal-filter-form');
    $('.filters__modal-footer')
        .on('click', '#btnFilter', () => {
            refreshRankingPage(false, $modalFiltersForm.serialize());
        });
    $modalFiltersForm
        .on('change', '[name="group_mode_subject"]', function () {
            const $modalStatus = $modalFiltersForm.find('#modalStatus');
            $modalStatus.val(true);
            toggleGroupModeSubjectFilter($(this));
        });
    const $activeModeSubjectFilter = $('.filters-radio-group').find('.active [name="group_mode_subject"]');
    if (parseInt($activeModeSubjectFilter.val(), 10)) {
        $wrapper
            .on('change', '#filters [name="ranking"]', () => {
                refreshRankingPage(false, null);
            })
            .on('change', '[name="mode"]', refreshRankingPage);
    }
}

function toggleGroupModeSubjectFilter($selector) {
    const $form = $selector.closest('form');
    const $organizationSelect = $form.find('select.organization-filter');
    if ($organizationSelect.val()) {
        const $ugsSelect = $form.find('#ugs');
        let queryParams = $form.serialize();
        if ($ugsSelect.length) {
            const organizationId = $organizationSelect.find('option:selected').attr('data-id');
            queryParams = removeQueryParam(queryParams, 'name');
            queryParams = appendQueryParam(queryParams, 'organization', organizationId);
        } else {
            const organizationName = $organizationSelect.find('option:selected').attr('data-name');
            queryParams = removeQueryParam(queryParams, 'organization');
            queryParams = appendQueryParam(queryParams, 'name', organizationName);
        }
        refreshRankingPage(false, queryParams);
    } else {
        refreshRankingPage(false);
    }
}
